import { Seo } from "../components/Seo";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { StickyCall } from "../components/StickyCall";
import { Marquee } from "../components/Marquee";
import { Hero } from "../components/sections/Hero";
import { TrustBar } from "../components/sections/TrustBar";
import { Services } from "../components/sections/Services";
import { WhyChoose } from "../components/sections/WhyChoose";
import { HowItWorks } from "../components/sections/HowItWorks";
import { Reviews } from "../components/sections/Reviews";
import { LocationSEO } from "../components/sections/LocationSEO";
import { VisaCountries } from "../components/sections/VisaCountries";
import { Faq } from "../components/sections/Faq";
import { FAQS } from "../lib/site";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        title="Urgent Passport & Visa | Expedited Passport & Visa Services Washington DC"
        description="Need a passport fast? UPV Services offers trusted expedited passport, visa, and apostille services in Washington DC. 20+ years experience. Expedited & emergency processing. Call 202-457-4665."
        path="/"
        jsonLd={[faqSchema]}
      />
      <Header />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <TrustBar />
        <Marquee />
        <Services />
        <WhyChoose />
        <HowItWorks />
        <Reviews />
        <VisaCountries />
        <LocationSEO />
        <Faq />
      </main>
      <Footer />
      <StickyCall />
    </div>
  );
}
